// extracted by mini-css-extract-plugin
module.exports = {"item_p":"styles_item_p__EmYn3","img_mobile":"styles_img_mobile__1D0PB"};